export default __webpack_public_path__ + "static/media/swapIcon.80faf95a.svg";